module.exports = __webpack_public_path__ + "assets/9d346fc818e9e967b2bba2bcba03c440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artwork-5.png
// module id = 390
// module chunks = 1